(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MarkdownTextArea", [], factory);
	else if(typeof exports === 'object')
		exports["MarkdownTextArea"] = factory();
	else
		root["MarkdownTextArea"] = factory();
})(window, function() {
return 